// src/utils/request.ts

import { hideToast, showToast } from "./toast.tsx";

interface Props {
  errorMessage: string;
  submitButton: {
    text: string;
    button: HTMLButtonElement;
  };
  request: {
    url: string;
    method: string;
    headers?: Record<string, string>;
    credentials?: RequestCredentials;
    body?: Record<string, unknown>;
  };
  onSuccess?: (response: Response) => void;
}

export const sendRequest = async ({
  errorMessage,
  onSuccess,
  submitButton,
  request: { url, method, headers, credentials, body },
}: Props) => {
  try {
    hideToast();
    submitButton.button.disabled = true;
    submitButton.button.innerText = "Ładowanie...";

    const response = await fetch(url, {
      method: method,
      headers: headers || {
        "Content-Type": "application/json",
      },
      credentials: credentials || "same-origin",
      body: body ? JSON.stringify(body) : undefined,
    });

    if (response.ok) {
      if (onSuccess) onSuccess(response);
      return;
    }

    let message = "Wystąpił błąd";
    if (response.status === 429) {
      message = "Zbyt wiele zapytań. Spróbuj ponownie później.";
    } else if (response.status >= 500) {
      message = "Błąd serwera. Spróbuj ponownie później.";
    } else if (response.status === 401 || response.status === 403) {
      message = errorMessage;
    } else {
      // Try to get more specific error if available
      try {
        const contentType = response.headers.get("content-type");
        if (contentType && contentType.includes("application/json")) {
          const errorData = await response.json();
          if (errorData.error || errorData.message) {
            message = errorData.error || errorData.message;
          }
        }
      } catch (parseError: unknown) {
        console.error(parseError);
      }
    }
    showToast({ variant: "error", message });
  } catch (_) {
    showToast({
      variant: "error",
      message: "Błąd połączenia. Sprawdź połączenie internetowe i spróbuj ponownie.",
    });
  } finally {
    submitButton.button.disabled = false;
    submitButton.button.innerText = submitButton.text;
  }
};
